export class TipoMovimiento {
    id: number;
    descripcion:string;
  }